import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {Message} from '../../models/danhmuc/message';
import {CalendarDepart} from '../../models/calendar/calendardepart';
import {CalendarWeek} from '../../models/calendar/calendarweeks';
import {CalendarDepartWeek} from '../../models/calendar/calendardepartweek';
import {Calendar} from '../../models/calendar/calendar';
import {CalendarNewsLog} from '../../models/calendar/calendarnewslog';
import {CalendarDepartLog} from '../../models/calendar/calendardepartlog';
const apiUrl = `${environment.apiUrl}/api/calendardepart`;

@Injectable({
  providedIn: 'root'
})
export class CalendarDepartService {
  constructor(public httpService: HttpClient) { }

  public getAll(): Observable<CalendarDepart[]> {
    return this.httpService.get<CalendarDepart[]>(`${apiUrl}/getall`).pipe(
      map(data => data.map(data => new CalendarDepart().deserialize(data)))
    );
  }
  public add(params: Object): Observable<CalendarDepart>
  {
    return this.httpService.post(`${apiUrl}/add`, params).pipe(
      map(data => new CalendarDepart().deserialize(data)));

  }
  public update(params: Object): Observable<CalendarDepart>
  {
    return this.httpService.post(`${apiUrl}/update`, params).pipe(
      map(data => new CalendarDepart().deserialize(data)));

  }
  findByLogId(id: number): Observable<CalendarDepartLog[]> {
    return this.httpService.get<CalendarDepartLog[]>(`${apiUrl}/findbylog/${id}`).pipe(
      map(data => data.map(data => new CalendarDepartLog().deserialize(data)))
    );

  }
  public getCountByKeyword(keyword: string, type: string, staffId: number)
  {
    return this.httpService.get(`${apiUrl}/getcountbykeyword?keyword=${keyword}&ty=${type}&uid=${staffId}`).pipe(
      map(data => Number(data)));
  }
  public getById(id: number): Observable<CalendarDepart>
  {
    return this.httpService.get<CalendarDepart>(`${apiUrl}/findbyid/${id}`).pipe(
      map(data => new CalendarDepart().deserialize(data)),
      catchError(() => throwError('items not found'))
    );
  }
  public delete(id: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/delete/${id}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id delete not found'))
    );
  }
  findByDate(tuNgay: String, denNgay: String, donViId: String, status: number, suDung: number, type: number): Observable<CalendarDepart[]> {
    return this.httpService.get<CalendarDepart[]>(`${apiUrl}/findallbydate?fdate=${tuNgay}&tdate=${denNgay}&uid=${donViId}&st=${status}&sd=${suDung}&ty=${type}`).pipe(
      map(data => data.map(data => new CalendarDepart().deserialize(data)))
    );
  }
  findByMonth(month: number, year: number, donViId: number, status: number, suDung: number): Observable<CalendarDepart[]> {
    return this.httpService.get<CalendarDepart[]>(`${apiUrl}/findallbymonth?m=${month}&y=${year}&uid=${donViId}&st=${status}&sd=${suDung}`).pipe(
      map(data => data.map(data => new CalendarDepart().deserialize(data)))
    );
  }
  getDataByWeekYear(week: Number, year: Number, donViShare: String, status: number, suDung: number, donViId: number): Observable<CalendarDepartWeek[]> {
    return this.httpService.get<CalendarDepartWeek[]>(`${apiUrl}/getdatabyweekyear?w=${week}&y=${year}&sid=${donViShare}&st=${status}&sd=${suDung}&uid=${donViId}`).pipe(
      map(data => data.map(data => new CalendarDepartWeek().deserialize(data)))
    );

  }

  public getCountBySearch(keyword: string, tuNgay: String, denNgay: String, donViShare: String, status: number, suDung: number, donViId: number)
  {
    return this.httpService.get(`${apiUrl}/getcountbysearch?keyword=${keyword}&fdate=${tuNgay}&tdate=${denNgay}&sid=${donViShare}&st=${status}&sd=${suDung}&uid=${donViId}`).pipe(
      map(data => Number(data)));
  }
  public chuyenLichCongTac(id: number)
  {
    return this.httpService.get(`${apiUrl}/chuyenlichcongtac/${id}`).pipe(
      map(data => Number(data)));
  }
  findAllBySearchPaging(keyword: string, tuNgay: String, denNgay: String, donViShare: String, status: number, suDung: number, donViId: number, page: number, pageSize: number): Observable<CalendarDepart[]> {
    return this.httpService.get<CalendarDepart[]>(`${apiUrl}/getallbysearchpaging?keyword=${keyword}&fdate=${tuNgay}&tdate=${denNgay}&sid=${donViShare}&st=${status}&sd=${suDung}&uid=${donViId}&page=${page}&size=${pageSize}`).pipe(
      map(data => data.map(data => new CalendarDepart().deserialize(data)))
    );

  }
}
